import { ApiSchemas } from '..'
import { client } from '../client'
import { wrapEndpoint } from '../wrap'

export default {
  async get(id: number) {
    return wrapEndpoint(() =>
      client.GET('/exam-protocol/{id}', {
        params: {
          path: {
            id,
          },
        },
      }),
    )
  },

  async list(dto?: ApiSchemas['ListExamProtocolDto']) {
    return wrapEndpoint(() =>
      client.GET('/exam-protocol', {
        params: {
          query: dto,
        },
      }),
    )
  },

  async create(dto: ApiSchemas['CreateExamProtocolDto']) {
    return wrapEndpoint(() =>
      client.POST('/exam-protocol', {
        body: dto,
      }),
    )
  },

  async update(id: number, dto: ApiSchemas['UpdateExamProtocolDto']) {
    return wrapEndpoint(() =>
      client.PUT('/exam-protocol/{id}', {
        body: dto,
        params: {
          path: {
            id,
          },
        },
      }),
    )
  },

  async delete(id: number) {
    await wrapEndpoint(() =>
      client.DELETE('/exam-protocol/{id}', {
        params: {
          path: {
            id,
          },
        },
      }),
    )
  },
}
